<span class="timeline__fifteen-minutes-container">
  <span 
  [class]="'timeline__fifteen-minutes' + ' ' + status()"
  ></span>
</span>
